import React from 'react';
import { Target, Compass, Award } from 'lucide-react';
import { motion } from 'framer-motion';

const VisionMission = () => {
    const items = [
        {
            icon: <Compass size={40} className="text-gold-500" />,
            title: "Our Vision",
            description: "To be the premier provider of luxury home maintenance and improvement services in the Middle East, setting the standard for quality and elegance."
        },
        {
            icon: <Target size={40} className="text-gold-500" />,
            title: "Our Mission",
            description: "We are dedicated to delivering exceptional craftsmanship and personalized service, using the finest materials and techniques to enhance the beauty and value of every property."
        },
        {
            icon: <Award size={40} className="text-gold-500" />,
            title: "Our Goals",
            description: "To consistently exceed client expectations through reliability, innovation, and sustainable practices, ensuring complete satisfaction in every project."
        }
    ];

    return (
        <section className="py-20 bg-dark-900 text-white">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
                    {items.map((item, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: index * 0.2 }}
                            className="bg-dark-800 p-8 border border-gray-800 hover:border-gold-500 transition-all duration-300 group"
                        >
                            <div className="mb-6 bg-dark-900 w-16 h-16 rounded-full flex items-center justify-center group-hover:bg-gold-500/10 transition-colors">
                                {item.icon}
                            </div>
                            <h3 className="text-2xl font-serif mb-4 text-gold-400">{item.title}</h3>
                            <p className="text-gray-400 leading-relaxed font-light">
                                {item.description}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default VisionMission;
